import React, { useCallback, useRef, useState, useEffect, useMemo } from "react";
import "../../styles/schedule.css";
import ScheduleList from "../ScheduleList";
import dropdownIcon from "../../assets/icons/arrow_down.svg";
import calendar from "../../assets/icons/calendar_add.svg";
import { getText, TextId } from "../Util/TextHelper";
import { getCurrentTimeFormatted } from "../Util/TimeUtil";
import SessionModal from "../SessionModal";
import EditDailyScheduleModal from "../EditDailyScheduleModal";
import Modal from "../Modal";
import calendarHeart from "../../assets/icons/calendarHeart-bold.svg";
import { ZensoryModule } from "../../ZensoryModule";
import ConnectCalenderButton from "../ConnectCalenderButton";
import { LOGGER, LogLevel } from "../Util/Logger";

const Schedule = ({ showCalenderModal = false, isGetSchduleData, handleIsGetSchduleData}) => {

  const [scheduleData, setScheduleData] = useState([]);
  const [isLoadingScheduleData, setIsLoadingScheduleData] = useState(false);
  const userNotFound = useMemo(() => {
    return ["none", null].includes(ZensoryModule.getAuth().getCurrentUser());
  }, [ZensoryModule.getAuth().getCurrentUser()]);
  const [isAddSessionModalOpen, setIsAddSessionModalOpen] = useState(false);
  const [isEditDailyScheduleModalOpen, setIsEditDailyScheduleModalOpen] =
    useState(false);
  const [editingSession, setEditingSession] = useState(null);
  const [showEarlierBtn, setShowEarlierBtn] = useState(false);
  const [showPulse, setShowPulse] = useState(false);
  const [defaultScheduleData, setDefaultScheduleData] = useState({
    startOfDay: {
      id: "",
      time: "",
    },
    postLunch: {
      id: "",
      time: "",
    },
    windDown: {
      id: "",
      time: "",
    },
  });

  const listRef = useRef(null);

  // Shared function to fetch and update schedule data
  const fetchAndUpdateScheduleData = async () => {
    try {
      const userId = ZensoryModule.getAuth().getCurrentUser();
      if (userId && !showCalenderModal) {
        setIsLoadingScheduleData(true);
        const response =
          await ZensoryModule.getCalenderApi().getCalenderschedule({
            userId,
          });

        const events = response?.result?.events || [];
        setScheduleData(events);
        const defaultEvents = response?.result?.defaultSessions || [];
        handleIsGetSchduleData()

        // Reset default schedule data to default values first
        setDefaultScheduleData({
          startOfDay: {
            id: "",
            time: "",
          },
          postLunch: {
            id: "",
            time: "",
          },
          windDown: {
            id: "",
            time: "",
          },
        });

        // Extract daily schedule data from the events
        const existingDailyEvents =
            defaultEvents?.filter(
            (event) =>
                event?.categories &&
            (event?.categories.includes("Zensory-morning") ||
            event?.categories.includes("Zensory-post-lunch") ||
            event?.categories.includes("Zensory-wind-down"))
        ) || [];

        existingDailyEvents.forEach((event) => {
            if (event?.categories?.includes("Zensory-morning")) {
                setDefaultScheduleData((d) => {
                    return {
                        ...d,
                        startOfDay: {
                            id: event.id,
                            time: getCurrentTimeFormatted(event.start?.dateTime),
                        },
                    };
                });
            } else if (event?.categories?.includes("Zensory-post-lunch")) {
                setDefaultScheduleData((d) => {
                    return {
                        ...d,
                        postLunch: {
                            id: event.id,
                            time: getCurrentTimeFormatted(event.start?.dateTime),
                        },
                    };
                });
            } else if (event?.categories?.includes("Zensory-wind-down")) {
                setDefaultScheduleData((d) => {
              return {
                ...d,
                windDown: {
                  id: event.id,
                  time: getCurrentTimeFormatted(event.start?.dateTime),
                },
              };
            });
          }
        });
      }
    } catch (error) {
      LOGGER.log(LogLevel.DEBUG, `Error in fetchAndUpdateScheduleData: ${JSON.stringify(error)}`);
    } finally {
      setIsLoadingScheduleData(false);
      handleIsGetSchduleData()
    }
  };

  const getSchedules = async () => {
    await fetchAndUpdateScheduleData();
  };

  useEffect(() => {
    getSchedules();
  }, []);

  useEffect(() => {
    if(isGetSchduleData){
        getSchedules();
    }
  }, [isGetSchduleData]);

  const handleAddSession = () => {
    setIsAddSessionModalOpen(true);
    setEditingSession(null);
  };

  const handleSubmitSession = async () => {
    try {
      await fetchAndUpdateScheduleData();
      setIsAddSessionModalOpen(false);
      setEditingSession(null);
    } catch (error) {
      LOGGER.log(LogLevel.DEBUG, `Error submitting session - handleSubmitSession: ${JSON.stringify(error)}`);
    }
  };
  const handleEditSession = useCallback((session) => {
    setEditingSession(session);
    setIsAddSessionModalOpen(true);
  }, []);

  const handleOnCloseModal = () => {
    setIsAddSessionModalOpen(false);
    setEditingSession(null);
  };

  const handleOpenDailyScheduleModal = async () => {
    setIsEditDailyScheduleModalOpen(false);
    await getSchedules();
    setIsEditDailyScheduleModalOpen(true);
  };

  const handleCloseDailyScheduleModal = () => {
    setIsEditDailyScheduleModalOpen(false);
  };

  const handleSaveDailySchedule = async () => {
    try {
      await fetchAndUpdateScheduleData();
      setIsAddSessionModalOpen(false);
      setIsEditDailyScheduleModalOpen(false);
      setEditingSession(null);
    } catch (error) {
      LOGGER.log(LogLevel.DEBUG, `Error submitting Default session - handleSaveDailySchedule: ${JSON.stringify(error)}`);
    } finally {
        setIsEditDailyScheduleModalOpen(false);
    }
  };

 const handleSessionScroll = (direction = 1) => {
  if (direction !== 1 && direction !== -1) return;
  const container = listRef.current;
  if (!container) return;

    const totalCards = scheduleData?.length;
    const cardHeight = container.scrollHeight / totalCards;
    const visibleCards = 3;
    const scrollAmount = cardHeight * visibleCards + 7;

    let newScrollTop;

    if (direction === 1) {
      newScrollTop = container.scrollTop + scrollAmount;
    } else if (direction === -1) {
      newScrollTop = container.scrollTop - scrollAmount;
      if (newScrollTop <= 0) {
        newScrollTop = 0;
      }
    }

    container.scrollTo({ top: newScrollTop, behavior: "smooth" });
  };
  useEffect(() => {
    const container = listRef.current;

    const handleScroll = () => {
      const currentContainer = listRef.current;
      if (!currentContainer) return;
      setShowEarlierBtn(currentContainer.scrollTop > 10);
      const { scrollTop, scrollHeight, clientHeight } = currentContainer;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
      setShowPulse(!isAtBottom);
    };

    if (container) {
      container.addEventListener("scroll", handleScroll);
      // Initial check in case content is already scrolled
      handleScroll();
    }

    return () => {
      const currentContainer = listRef.current;
      if (currentContainer) {
        currentContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [scheduleData?.length]); // Add dependency on scheduleData length so it re-runs when data changes

  return (
    <>
      <div className="schedule-container">
        <div className="column-one">
          <span className="column-one-title">
            {getText(TextId.scheduleTitle)}
          </span>
          <span className="column-one-subtitle">
            {getText(TextId.scheduleSubtitle)}
          </span>
        </div>
        <div
          className={`column-two ${
            !showCalenderModal ? "col-two-loading" : ""
          }`}
        >
          {showCalenderModal || userNotFound ? (
            <div className="schedule-list-container">
              <div className="noCal-wrapper ">
                <div className="noCal-container">
                  <div className="noCal-content">
                    <div>
                      <img src={calendarHeart} alt="calender-heart" />
                    </div>
                    <div className="noCal-message">
                      <span className="noCal-message-label">
                        {getText(TextId.calenderModalTitle)}
                      </span>
                      <span className="noCal-message-info">
                        {userNotFound
                          ? getText(TextId.calenderLoginBoxHeadingUserNotFound)
                          : getText(TextId.calenderLoginBoxHeading)}
                      </span>
                    </div>
                    {!userNotFound && <ConnectCalenderButton />}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="schedule-list-container">
                {showEarlierBtn && (
                  <div
                    className="more-session-button"
                    onClick={() => handleSessionScroll(-1)}
                  >
                    {getText(TextId.earlierSessionButton)}
                    <span>
                      <img
                        src={dropdownIcon}
                        alt="dropdown icon"
                        style={{ transform: "rotate(180deg)" }}
                      />
                    </span>
                  </div>
                )}
                {!isLoadingScheduleData ? (
                  <ScheduleList
                    ref={listRef}
                    scheduleData={scheduleData}
                    onEditSession={handleEditSession}
                  />
                ) : (
                  <>
                    <div className="loading-container">
                      <h3 style={{ color: "white", fontFamily: "Poppins" }}>
                        {getText(TextId.loadingText)}
                      </h3>
                    </div>
                  </>
                )}
                {scheduleData?.length > 0 && (
                  <div
                    className={`more-session-button ${
                      showPulse ? "pulse" : ""
                    }`}
                    onClick={() => handleSessionScroll(1)}
                  >
                    {getText(TextId.laterSessionButton)}
                    <span>
                      <img src={dropdownIcon} alt="dropdown icon" />
                    </span>
                  </div>
                )}

                <div
                  className="add-session-button custom-gradient-border"
                  onClick={handleAddSession}
                >
                  {getText(TextId.addSessionButton)}
                  <img src={calendar} alt="calendar" />
                </div>
                {!isLoadingScheduleData &&(
                  <div
                    className="default-timing-link"
                    onClick={handleOpenDailyScheduleModal}
                  >
                    {getText(TextId.setDailyDefaultTimings)}
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        {(isAddSessionModalOpen || editingSession) && (
          <Modal
            isOpen={isAddSessionModalOpen || !!editingSession}
            onClose={handleOnCloseModal}
          >
            <SessionModal
              isCreate={!editingSession}
              initialData={editingSession}
              onClose={handleOnCloseModal}
              onSubmit={handleSubmitSession}
            />
          </Modal>
        )}

        {isEditDailyScheduleModalOpen && (
          <Modal
            isOpen={isEditDailyScheduleModalOpen}
            onClose={handleCloseDailyScheduleModal}
          >
            <EditDailyScheduleModal
              initialData={defaultScheduleData}
              onClose={handleCloseDailyScheduleModal}
              onSubmit={handleSaveDailySchedule}
            />
          </Modal>
        )}
      </div>
    </>
  );
};

export default Schedule;
